import ModalDeleteFilled from '../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import ModalSmallFilled from '../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'
import { ModalEditComponentProps } from '../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'

interface ModalChangeActiveCustomerWCProps extends ModalEditComponentProps { }

const ModalChangeActiveCustomerWC: React.FC<ModalChangeActiveCustomerWCProps> = ({ setOpened, onSubmit, allRowData }) => {
    if (allRowData?.active === false) {
        return <ModalReactivateCustomerWC {...{ setOpened, onSubmit, allRowData }} />
    } else {
        return <ModalDeleteCustomerWC {...{ setOpened, onSubmit, allRowData }} />
    }
}

interface ModalDeleteCustomerWCProps extends ModalEditComponentProps { }

const ModalDeleteCustomerWC: React.FC<ModalDeleteCustomerWCProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/customer/customerShop/updateCustomerShop',
        data: {
            id: allRowData?.id,
            active: false,
            CustomerId: allRowData?.CustomerId
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureUnactiveWorkingCenter', '¿Seguro que quieres desactivar este centro de trabajo?'),
            subtitle: t('onceDisabledCanRecoverM', 'Una vez desactivado podrás recuperarlo'),
            buttonAccept: t('disable', 'Desactivar'),
        }} />
    )
}

interface ModalReactivateCustomerWCProps extends ModalEditComponentProps { }

const ModalReactivateCustomerWC: React.FC<ModalReactivateCustomerWCProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/customer/customerShop/updateCustomerShop',
        data: {
            id: allRowData?.id,
            active: true,
            CustomerId: allRowData?.CustomerId
        }
    })
    return (
        <ModalSmallFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureReactiveThisWorkingCenter', '¿Seguro que quieres reactivar este centro de trabajo?'),
            subtitle: t('onceReactivatedAbleInWorkingCenterList', 'Una vez reactivado volverá a aparecer en el listado de centros de trabajo'),
            buttonAccept: t('reactivate', 'Reactivar')
        }} />
    )
}

export default ModalChangeActiveCustomerWC